import { Keyboards } from "@typings/global.types";

// TODO: rename keyboards->KEYBOARDS
export const keyboards: Keyboards = {
  qwerty: {
    name: "English",
    default: [
      "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w e r t y u i o p [ ] \\",
      "{lock} a s d f g h j k l ; ' {enter}",
      "{shift} z x c v b n m , . / {shift}",
      "{space}",
    ],
    shift: [
      "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
      "{tab} Q W E R T Y U I O P { } |",
      '{lock} A S D F G H J K L : " {enter}',
      "{shift} Z X C V B N M < > ? {shift}",
      "{space}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c6 c2 c2 c2 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c6 c2 c2 c2 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c6 c2 c2 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c6 c2 kShiftR",
      "kSpace",
    ],
    acceptedKeys: "qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM",
    shiftElements: '~!@#$%^&*()_+QWERTYUIOP{}|ASDFGHJKL:"ZXCVBNM<>?',
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Caps",
      tab: "Tab",
      bksp: "←",
      space: " ",
    },
  },
  dvorak: {
    name: "English",
    default: [
      "§ 1 2 3 4 5 6 7 8 9 0 [ ] {bksp}",
      "{tab} ' , . p y f g c r l / = \\",
      "{lock} a o e u i d h t n s - {enter}",
      "{shift} ; q j k x b m w v z {shift}",
      "{space}",
    ],
    shift: [
      "± ! @ # $ % ^ & * ( ) { } {bksp}",
      '{tab} " < > P Y F G C R L ? + |',
      "{lock} A O E U I D H T N S _ {enter}",
      "{shift} : Q J K X B M W V Z {shift}",
      "{space}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    acceptedKeys: "qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM§±",
    shiftElements: '±!@#$%^&*(){}"<>PYFGCRL?+|AOEUIDHTNS_:QJKXBMWVZ',
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Caps",
      tab: "Tab",
      bksp: "←",
      space: " ",
    },
  },
  russian: {
    name: "Русский",
    default: [
      "\u0451 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} \u0439 \u0446 \u0443 \u043a \u0435 \u043d \u0433 \u0448 \u0449 \u0437 \u0445 \u044a \\",
      "{lock} \u0444 \u044b \u0432 \u0430 \u043f \u0440 \u043e \u043b \u0434 \u0436 \u044d {enter}",
      "{shift} \u044f \u0447 \u0441 \u043c \u0438 \u0442 \u044c \u0431 \u044e . {shift}",
      "{space}",
    ],
    shift: [
      '\u0401 ! " \u2116 ; % : ? * ( ) _ + {bksp}',
      "{tab} \u0419 \u0426 \u0423 \u041a \u0415 \u041d \u0413 \u0428 \u0429 \u0417 \u0425 \u042a /",
      "{lock} \u0424 \u042b \u0412 \u0410 \u041f \u0420 \u041e \u041b \u0414 \u0416 \u042d {enter}",
      "{shift} \u042f \u0427 \u0421 \u041c \u0418 \u0422 \u042c \u0411 \u042e , {shift}",
      "{space}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    acceptedKeys:
      "йцукенгшщзхъфывапролджэёячсмитьбюЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЁЯЧСМИТЬБЮ№",
    shiftElements:
      '\u0401!"\u2116;%:?*()_+\u0419\u0426\u0423\u041a\u0415\u041d\u0413\u0428\u0429\u0417\u0425\u042a/\u0424\u042b\u0412\u0410\u041f\u0420\u041e\u041b\u0414\u0416\u042d\u042f\u0427\u0421\u041c\u0418\u0422\u042c\u0411\u042e,',
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Caps",
      tab: "Tab",
      bksp: "←",
      space: " ",
    },
  },
  ukrainian: {
    name: "Українська",
    default: [
      "\u0027 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} \u0439 \u0446 \u0443 \u043a \u0435 \u043d \u0433 \u0448 \u0449 \u0437 \u0445 \u0457 \\",
      "{lock} \u0444 \u0456 \u0432 \u0430 \u043f \u0440 \u043e \u043b \u0434 \u0436 \u0454 {enter}",
      "{shift} \u044f \u0447 \u0441 \u043c \u0438 \u0442 \u044c \u0431 \u044e . {shift}",
      "{space} {alt}",
    ],
    shift: [
      '\u007E ! " \u2116 ; % : ? * ( ) _ + {bksp}',
      "{tab} \u0419 \u0426 \u0423 \u041a \u0415 \u041d \u0413 \u0428 \u0429 \u0417 \u0425 \u0407 /",
      "{lock} \u0424 \u0406 \u0412 \u0410 \u041f \u0420 \u041e \u041b \u0414 \u0416 \u0404 {enter}",
      "{shift} \u042f \u0427 \u0421 \u041c \u0418 \u0422 \u042c \u0411 \u042e , {shift}",
      "{space} {alt}",
    ],
    alt: [
      "\u0027 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} \u0439 \u0446 \u0443 \u043a \u0435 \u043d \u0491 \u0448 \u0449 \u0437 \u0445 \u0457 \\",
      "{lock} \u0444 \u0456 \u0432 \u0430 \u043f \u0440 \u043e \u043b \u0434 \u0436 \u0454 {enter}",
      "{shift} \u044f \u0447 \u0441 \u043c \u0438 \u0442 \u044c \u0431 \u044e . {shift}",
      "{space} {alt}",
    ],
    "alt-shift": [
      '\u007E ! " \u2116 ; % : ? * ( ) _ + {bksp}',
      "{tab} \u0419 \u0426 \u0423 \u041a \u0415 \u041d \u0490 \u0428 \u0429 \u0417 \u0425 \u0407 /",
      "{lock} \u0424 \u0406 \u0412 \u0410 \u041f \u0420 \u041e \u041b \u0414 \u0416 \u0404 {enter}",
      "{shift} \u042f \u0427 \u0421 \u041c \u0418 \u0422 \u042c \u0411 \u042e , {shift}",
      "{space} {alt}",
    ],
    colors: [
      "c1 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace kAltR",
    ],
    acceptedKeys:
      "йцукенгшщзхїфивапролджєґячсмітьбюЙЦУКЕНГШЩЗХЇФИВАПРОЛДЖЄҐЯЧСМІТЬБЮ№’",
    shiftElements:
      '\u007E!"\u2116;%:?*()_+\u0419\u0426\u0423\u041a\u0415\u041d\u0413\u0428\u0429\u0417\u0425\u0407/\u0424\u0406\u0412\u0410\u041f\u0420\u041e\u041b\u0414\u0416\u0404\u042f\u0427\u0421\u041c\u0418\u0422\u042c\u0411\u042e,',
    altElements: "\u0491",
    shiftAltElements: "\u0490",
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Caps",
      tab: "Tab",
      bksp: "←",
      space: " ",
    },
  },
  "ukrainian-mac": {
    name: "Українська",
    default: [
      "\u0491 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} \u0439 \u0446 \u0443 \u043A \u0435 \u043D \u0433 \u0448 \u0449 \u0437 \u0445 \u0457 ʼ",
      "{lock} \u0444 \u0456 \u0432 \u0430 \u043F \u0440 \u043E \u043B \u0434 \u0436 \u0454 {enter}",
      "{shift} \u044F \u0447 \u0441 \u043C \u0438 \u0442 \u044C \u0431 \u044E . {shift}",
      "{space}",
    ],
    shift: [
      '\u0490 ! " \u2116 ; % : ? * ( ) _ + {bksp}',
      "{tab} \u0419 \u0426 \u0423 \u041A \u0415 \u041D \u0413 \u0428 \u0429 \u0417 \u0425 \u0407 \u20B4",
      "{lock} \u0424 \u0406 \u0412 \u0410 \u041F \u0420 \u041E \u041B \u0414 \u0416 \u0404 {enter}",
      "{shift} \u042F \u0427 \u0421 \u041C \u0418 \u0422 \u042C \u0411 \u042E , {shift}",
      "{space}",
    ],
    colors: [
      "c1 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    acceptedKeys:
      "йцукенгшщзхїфивапролджєґячсмітьбюЙЦУКЕНГШЩЗХЇФИВАПРОЛДЖЄҐЯЧСМІТЬБЮ№’ʼ",
    shiftElements:
      '\u0490 ! " \u2116 ; % : ? * ( ) _ + \u0419 \u0426 \u0423 \u041A \u0415 \u041D \u0413 \u0428 \u0429 \u0417 \u0425 \u0407 \u20B4 \u0424 \u0406 \u0412 \u0410 \u041F \u0420 \u041E \u041B \u0414 \u0416 \u0404 \u042F \u0427 \u0421 \u041C \u0418 \u0422 \u042C \u0411 \u042E',
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Caps",
      tab: "Tab",
      bksp: "←",
      space: " ",
    },
  },
  azerty: {
    name: "Français",
    default: [
      "² & é \" ' ( - è _ ç à ) = {bksp}",
      "{tab} a z e r t y u i o p ^ $ *",
      "{lock} q s d f g h j k l m ù {enter}",
      "{shift} w x c v b n , ; : ! {shift}",
      "{space}",
    ],
    shift: [
      "> 1 2 3 4 5 6 7 8 9 0 ° + {bksp}",
      "{tab} A Z E R T Y U I O P ¨ £ μ",
      "{lock} Q S D F G H J K L M Ù {enter}",
      "{shift} W X C V B N ? . / § {shift}",
      "{space}",
    ],
    "^": [
      "² & é \" ' ( - è _ ç à ) = {bksp}",
      "{tab} â z ê r t y û î ô p ^ $ *",
      "{lock} q s d f g h j k l m ù {enter}",
      "{shift} w x c v b n , ; : ! {shift}",
      "{space}",
    ],
    "^-shift": [
      "> 1 2 3 4 5 6 7 8 9 0 ° + {bksp}",
      "{tab} Â Z Ê R T Y Û Î Ô P ¨ £ μ",
      "{lock} Q S D F G H J K L M Ù {enter}",
      "{shift} W X C V B N ? . / § {shift}",
      "{space}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    deadKey: "^", // ¨ немає
    acceptedKeys:
      "azertyuiopqsdfghjklmùwxcvbnâêûîôäëüïöAZERTYUIOPQSDFGHJKLMÙWXCVBNÂÊÛÎÔÄËÜÏÖ²éèçàμ£ÉÈÇÀ°ẑŝĝĥĵŵĉế⁽⁻ềầ⁾⁼⁽⁻⁾⁼ẐŜĜĤĴŴĈ€¨",
    acceptedWithDeadKey: "âêûîôÂÊÛÎÔäëüïöÄËÜÏÖẑŝĝĥĵŵĉế⁽⁻ềầ⁾⁼⁽⁻⁾⁼ẐŜĜĤĴŴĈ",
    deadKeyElements: {
      "^": "âêûîôÂÊÛÎÔẑŝĝĥĵŵĉẐŜĜĤĴŴĈ",
    },
    shiftElements: '±!@#%^&*(){}"<>PYFGCRL?+|AOEUIDHTNS_:QJKXBMWVZ',
    specialKeyNames: {
      shift: "May",
      enter: "Entrée",
      lock: "Verr may",
      tab: "Tab",
      bksp: "←",
      space: " ",
    },
    deadKeySpecialKeyNames: {
      BracketLeft: "^",
    },
  },
  qwerty_es: {
    name: "Español",
    default: [
      "º 1 2 3 4 5 6 7 8 9 0 ' ¡ {bksp}",
      "{tab} q w e r t y u i o p ` + ç",
      "{lock} a s d f g h j k l ñ ´ {enter}",
      "{shift} z x c v b n m , . - {shift}",
      "{space}",
    ],
    shift: [
      'ª ! " · $ % & / ( ) = ? ¿ {bksp}',
      "{tab} Q W E R T Y U I O P ^ * Ç",
      "{lock} A S D F G H J K L Ñ ¨ {enter}",
      "{shift} Z X C V B N M ; : _ {shift}",
      "{space}",
    ],
    "´": [
      "º 1 2 3 4 5 6 7 8 9 0 ' ¡ {bksp}",
      "{tab} q w é r t y ú í ó p ` + ç",
      "{lock} á s d f g h j k l ñ ´ {enter}",
      "{shift} z x c v b n m , . - {shift}",
      "{space}",
    ],
    "´-shift": [
      'ª ! " · $ % & / ( ) = ? ¿ {bksp}',
      "{tab} Q W É R T Y Ú Í Ó P ^ * Ç",
      "{lock} Á S D F G H J K L Ñ ¨ {enter}",
      "{shift} Z X C V B N M ; : _ {shift}",
      "{space}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    deadKey: "´",
    acceptedKeys:
      "º¡qwertyuiopçasdfghjklñ´zxcvbnmª·¿QWERTYUIOPÇASDFGHJKLÑ¨ZXCVBNM_èùìòàỳÈÙÌÒÀỲéúíóáýÉÚÍÓÁÝäëüïöÿÄËÜÏÖŸẁǹǜẀǛǸẃŕṕśǵḱĺḉźńḿẂŔṔŚǴḰĹŹḈŃḾẅẗḧẍẄḦ",
    acceptedWithDeadKey:
      "èùìòàỳÈÙÌÒÀỲéúíóáýÉÚÍÓÁÝäëüïöÿÄËÜÏÖŸẁǹǜẀǛǸẃŕṕśǵḱĺḉźńḿẂŔṔŚǴḰĹŹḈŃḾẅẗḧẍẄḦ",
    deadKeyElements: {
      "´": "éúíóáÉÚÍÓÁ",
    },
    shiftElements: 'ª!"·$%&/()=?¿QWERTYUIOP^*ÇASDFGHJKLÑ¨ZXCVBNM;:_ÉÚÍÓÁ',
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Bloq mayús",
      tab: "Tab",
      bksp: "←",
      space: " ",
    },
    deadKeySpecialKeyNames: {
      BracketLeft: "´",
      Quote: "´",
    },
  },
  qwerty_it: {
    name: "Italiano",
    default: [
      "\\ 1 2 3 4 5 6 7 8 9 0 ' ì {bksp}",
      "{tab} q w e r t y u i o p è + ù",
      "{lock} a s d f g h j k l ò à {enter}",
      "{shift} z x c v b n m , . - {shift}",
      "{space}",
    ],
    shift: [
      '| ! " £ $ % & / ( ) = ? ^ {bksp}',
      "{tab} Q W E R T Y U I O P é * §",
      "{lock} A S D F G H J K L ç ° {enter}",
      "{shift} Z X C V B N M ; : _ {shift}",
      "{space}",
    ],
    "`": [
      "\\ 1 2 3 4 5 6 7 8 9 0 ' ì {bksp}",
      "{tab} q w e r t y u i o p è +",
      "{lock} a s d f g h j k l ò à {enter}",
      "{shift} z x c v b n m , . - {shift}",
      "{space}",
    ],
    "`-shift": [
      '| ! " £ $ % & / ( ) = ? ^ {bksp}',
      "{tab} Q W E R T Y U I O P È +",
      "{lock} A S D F G H J K L Ò À {enter}",
      "{shift} Z X C V B N M ; : _ {shift}",
      "{space}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    deadKey: "`",
    acceptedKeys:
      'ìùqwertyuiopè+asdfghjklòàzxcvbnm,.-QWERTYUIOPÈASDFGHJKLÀZXCVBNM;:_|!"£$%&/()=?^+é*§ç°ÒÀ',
    acceptedWithDeadKey: "èòàÈÀ",
    deadKeyElements: {
      "`": "èòàÈÀ",
    },
    shiftElements: '|!"£$%&/()=?^QWERTYUIOPÈ+é*§ASDFGHJKLç°ZXCVBNM;:_ÒÀ',
    specialKeyNames: {
      shift: "MAIUSC",
      enter: "INVIO",
      lock: "BLOC MAIUSC",
      tab: "TAB",
      bksp: "←",
      space: " ",
    },
  },
  qwerty_de: {
    name: "Deutsche",
    default: [
      "< 1 2 3 4 5 6 7 8 9 0 ß ´ {bksp}",
      "{tab} q w e r t z u i o p ü + #",
      "{lock} a s d f g h j k l ö ä {enter}",
      "{shift} y x c v b n m , . - {shift}",
      "{space}",
    ],
    shift: [
      '> ! " § $ % & / ( ) = ? ` {bksp}',
      "{tab} Q W E R T Z U I O P Ü * '",
      "{lock} A S D F G H J K L Ö Ä {enter}",
      "{shift} Y X C V B N M ; : _ {shift}",
      "{space}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    acceptedKeys:
      "1234567890ß!\"§$%&/()=?`qwertzuiopü+asdfghjklöäyxcvbnm,.-QWERTZUIOPÜ*'ASDFGHJKLÖÄYXCVBNM;:_",
    shiftElements: ">!\"§$%&/()=?`QWERTZUIOPÜ*'ASDFGHJKLÖÄYXCVBNM;:_",
    specialKeyNames: {
      shift: "UMSCH",
      enter: "EINGABE",
      lock: "FEST",
      tab: "TAB",
      bksp: "←",
      space: " ",
    },
  },
  qwerty_pt_br: {
    name: "Portuguese (Brasil)",
    default: [
      "' 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w e r t y u i o p ´ [ ]",
      "{lock} a s d f g h j k l ç ~ {enter}",
      "{shift} z x c v b n m , . ; {shift}",
      "{space}",
    ],
    shift: [
      '" ! @ # $ % ¨ & * ( ) _ + {bksp}',
      "{tab} Q W E R T Y U I O P ` { }",
      "{lock} A S D F G H J K L Ç ^ {enter}",
      "{shift} Z X C V B N M < > : {shift}",
      "{space}",
    ],
    "^": [
      "' 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w ê r t y u i ô p ´ [ ]",
      "{lock} â s d f g h j k l ç ~ {enter}",
      "{shift} z x c v b n m , . ; {shift}",
      "{space}",
    ],
    "^-shift": [
      '" ! @ # $ % ¨ & * ( ) _ + {bksp}',
      "{tab} Q W Ê R T Y U I Ô P ` { }",
      "{lock} Â S D F G H J K L Ç ^ {enter}",
      "{shift} Z X C V B N M < > : {shift}",
      "{space}",
    ],
    "´": [
      "' 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w é r t y ú í ó p ´ [ ]",
      "{lock} á s d f g h j k l ç ~ {enter}",
      "{shift} z x c v b n m , . ; {shift}",
      "{space}",
    ],
    "´-shift": [
      '" ! @ # $ % ¨ & * ( ) _ + {bksp}',
      "{tab} Q W É R T Y Ú Í Ó P ` { }",
      "{lock} Á S D F G H J K L Ç ^ {enter}",
      "{shift} Z X C V B N M < > : {shift}",
      "{space}",
    ],
    "`": [
      "' 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w è r t y ù ì ò p ´ [ ]",
      "{lock} à s d f g h j k l ç ~ {enter}",
      "{shift} z x c v b n m , . ; {shift}",
      "{space}",
    ],
    "`-shift": [
      '" ! @ # $ % ¨ & * ( ) _ + {bksp}',
      "{tab} Q W È R T Y Ù Ì Ò P ` { }",
      "{lock} À S D F G H J K L Ç ^ {enter}",
      "{shift} Z X C V B N M < > : {shift}",
      "{space}",
    ],
    "~": [
      "' 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w e r t y u i õ p ´ [ ]",
      "{lock} ã s d f g h j k l ç ~ {enter}",
      "{shift} z x c v b n m , . ; {shift}",
      "{space}",
    ],
    "~-shift": [
      '" ! @ # $ % ¨ & * ( ) _ + {bksp}',
      "{tab} Q W E R T Y U I Õ P ` { }",
      "{lock} Ã S D F G H J K L Ç ^ {enter}",
      "{shift} Z X C V B N M < > : {shift}",
      "{space}",
    ],
    colors: [
      "c1 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    deadKey: "^´`~",
    acceptedWithDeadKey: "^´`~˜ˆêèéàáâãíìòóôõúùÊÈÉÀÁÂÃÍÌÒÓÔÕÚÙ",
    acceptedKeys:
      '1234567890-=qwertyuiop[]asdfghjklç~zxcvbnm,.;"!@#$%¨&*()_+QWERTYUIOP{}ASDFGHJKLÇ^ZXCVBNM<>:êèéàáâãíìòóôõúùÊÈÉÀÁÂÃÍÌÒÓÔÕÚÙ^´`~˜ˆ',
    deadKeyElements: {
      "^": "êâôÊÂÔ",
      "´": "éáíóúÉÁÍÓÚ",
      "`": "èàìòùÈÀÌÒÙ",
      "~": "ãõÃÕ",
    },
    shiftElements:
      '"!@#$%¨&*()_+QWERTYUIOP`ASDFGHJKLÇ^ZXCVBNM<>:ÊÈÉÀÁÂÃÍÌÒÓÔÕÚÙ',
    specialKeyNames: {
      shift: "Shift",
      enter: "enter",
      lock: "Fixa",
      tab: "TAB",
      bksp: "←",
      space: " ",
    },
    deadKeySpecialKeyNames: {
      ShiftQuote: "^",
      ShiftBracketLeft: "`",
      BracketLeft: "´",
      Quote: "~",
    },
  },
  qwerty_pl: {
    name: "Polski",
    default: [
      "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w e r t y u i o p [ ] \\",
      "{lock} a s d f g h j k l ; ' {enter}",
      "{shift} z x c v b n m , . / {shift}",
      "{space} {alt}",
    ],
    shift: [
      "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
      "{tab} Q W E R T Y U I O P { } |",
      '{lock} A S D F G H J K L : " {enter}',
      "{shift} Z X C V B N M < > ? {shift}",
      "{space} {alt}",
    ],
    alt: [
      "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w ę r t y u i ó p [ ] «",
      "{lock} ą ś d f g h j k ł ; ' {enter}",
      "{shift} ż ź ć v b ń m , . / {shift}",
      "{space} {alt}",
    ],
    "alt-shift": [
      "¬ ŕ Ř ‹ › ř Ŗ ŗ ° Š ‚ — Ī {bksp}",
      "{tab} ő „ Ę £ ś Á Ť ť Ó ł ” ’ »",
      "{lock} Ą Ś Ž ž Ū Ó Ô ū Ł Ú ģ {enter}",
      "{shift} Ż Ź Ć ◊ ű Ń ų Ý ý ņ {shift}",
      "{space} {alt}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace kAltR",
    ],
    acceptedWithDeadKey: "Ďōüēöä",
    acceptedKeys:
      "qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNMŌ∑ę®†ī^óĻ„‚ąś∂ń©ķ∆Żł…ĺ«żźć√ļĶ≤≥÷ő„Ę£śÁŤťÓł”’ĄŚŽžŪÓÔūŁÚģ»ŔŻŹĆ◊űŃųÝýņ¬™€ßį§¶•Ľľ–≠ōżļķĎōüēöäď¨ř—ŕŘ‹›Ŗŗ°Š‚Ī",
    shiftElements: '~!@#$%^&*()_+QWERTYUIOP{}|ASDFGHJKL:"ZXCVBNM<>?',
    altElements: "ąśęóżźćń",
    shiftAltElements: "¬ŕŘ‹›ř°Š‚—Īő„Ę£śÁŤťÓł”’ĄŚŽžŪÓÔūŁÚģ»ŔŻŹĆ◊űŃųÝýņ",
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Caps",
      tab: "Tab",
      bksp: "←",
      space: " ",
      alt: "Alt",
    },
  },
  qwerty_tr: {
    name: "Türkçe",
    default: [
      '" 1 2 3 4 5 6 7 8 9 0 * - {bksp}',
      "{tab} q w e r t y u ı o p ğ ü ,",
      "{lock} a s d f g h j k l ş i {enter}",
      "{shift} z x c v b n m ö ç . {shift}",
      "{space}",
    ],
    shift: [
      "é ! ' ^ + % & / ( ) = ? _ {bksp}",
      "{tab} Q W E R T Y U I O P Ğ Ü ;",
      "{lock} A S D F G H J K L Ş İ {enter}",
      "{shift} Z X C V B N M Ö Ç : {shift}",
      "{space}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace",
    ],
    acceptedKeys:
      '1234567890-=qwertyuiop[]asdfghjklç~zxcvbnm,.;"!@#$%¨&*()_+QWERTYUIOP{}ASDFGHJKLÇ^ZXCVBNM<>:^´`~˜ˆığüöçşéİĞÜŞÇÖÉ',
    shiftElements: "é!'^+%&/()=?_QWERTYUIOPĞÜ;ASDFGHJKLŞİZXCVBNMÖÇ:",
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Caps",
      tab: "Tab",
      bksp: "←",
      space: " ",
      alt: "Alt",
    },
  },
  qwerty_nl: {
    name: "Nederlands",
    default: [
      "@ 1 2 3 4 5 6 7 8 9 0 / ° {bksp}",
      "{tab} q w e r t y u i o p ¨ * <",
      "{lock} a s d f g h j k l + ´ {enter}",
      "{shift} z x c v b n m , . - {shift}",
      "{space} {alt}",
    ],
    shift: [
      "§ ! \" # $ % & _ ( ) ' ? ~ {bksp}",
      "{tab} Q W E R T Y U I O P ^ | >",
      "{lock} A S D F G H J K L ± ` {enter}",
      "{shift} Z X C V B N M ; : = {shift}",
      "{space} {alt}",
    ],
    colors: [
      "c0 c1 c1 c2 c3 c4 c4 c5 c3 c2 c1 c1 c1 kBack",
      "kTab c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 c1 kSlash",
      "kCaps c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 c1 kEnter",
      "kShift c1 c2 c3 c4 c4 c5 c5 c3 c2 c1 kShiftR",
      "kSpace kAltR",
    ],
    acceptedKeys:
      '1234567890-=qwertyuiop[]asdfghjklç~zxcvbnm,.;"!@#$%¨&*()_+QWERTYUIOP{}ASDFGHJKLÇ^ZXCVBNM<>:^´`~˜ˆ°',
    specialKeyNames: {
      shift: "Shift",
      enter: "Enter",
      lock: "Caps",
      tab: "Tab",
      bksp: "←",
      space: " ",
      alt: "Alt",
    },
  },
};
